import DEFAULT_USER_PHOTO from '../../../assets/images/matchPlay_DefaultUserIcon.png'
import VS_IMAGE from '../../../assets/images/matchPlay_VS.png'

const COLOR_RED = "#ba000d";
const COLOR_BLUE    = "#0069c0";

const MatchCard = ({
    matchIndex, groupIndex, playerVs, winner, winnerHoles,
    registeredPlayers, type, userPhotoURL, onMatchClick,
}) => {
    const noData = !playerVs ||
        type === "Singles" ? (playerVs.User1ID === 0 || playerVs.User2ID === 0 ) : (playerVs.User1ID === 0 || playerVs.User2ID === 0 || playerVs.User3ID === 0 || playerVs.User4ID === 0);
    const isVerified = playerVs?.IsScoreVerified === "Y";
    const isSubmitted = playerVs?.IsCardSubmitted === "Y";

    const lhsReg = registeredPlayers.find(p => p.User1ID === playerVs?.User1ID);
    const rhsReg = registeredPlayers.find(p =>
        type === "Singles" ? p.User1ID === playerVs?.User2ID : p.User1ID === playerVs?.User3ID
    );

    const lhsUserId = playerVs?.User1ID;

    const clickable = !noData && !isVerified;


    // ─── VerificationBadge ────────────────────────────────────────────────────────
    const VerificationBadge = ({ isSubmitted, isVerified }) => {
        if (isVerified)
            return <span className="kt-badge kt-badge--success kt-badge--inline kt-badge--pill font-weight500 margin-r15 margin-t8">Verified</span>;
        if (isSubmitted)
            return <span className="kt-badge kt-badge--info kt-badge--inline kt-badge--pill font-weight500 margin-r15 margin-t8">Verification Pending</span>;
        return null;
    };

    // ─── PlayerSlot ───────────────────────────────────────────────────────────────
    const PlayerSlot = ({ player, userPhotoURL, side, handicap }) => {
        const borderColor = side === "lhs" ? COLOR_RED : COLOR_BLUE;
        const photo = player?.User1Photo ? `${userPhotoURL}${player.User1Photo}` : DEFAULT_USER_PHOTO;
        return (
            <div className="player player-holder-1 text-center">
                <img
                    src={photo}
                    className="img-responsive img-circle img-user player-image"
                    style={{ border: `4px solid ${borderColor}`, width: 60, height: 60 }}
                    alt=""
                    onError={e => { e.target.src = DEFAULT_USER_PHOTO; }}
                />
                <div className="padding-t10">
                    <span className="name"><b>{player ? player.User1Name : "TBA"}</b></span>
                </div>
                <div className="handicap"><b>({handicap ?? 0})</b></div>
            </div>
        );
    };

    // ─── DoublesSlot ──────────────────────────────────────────────────────────────
    const DoublesSlot = ({ player, userPhotoURL, side, h1, h2 }) => {
        const borderColor = side === "lhs" ? COLOR_RED : COLOR_BLUE;
        const photo1 = player?.User1Photo ? `${userPhotoURL}${player.User1Photo}` : DEFAULT_USER_PHOTO;
        const photo2 = player?.User2Photo ? `${userPhotoURL}${player.User2Photo}` : DEFAULT_USER_PHOTO;
        return (
            <div className="player">
                <div className="row">
                    <div className="col-sm-6 text-center player-holder-1">
                        <img src={photo1} className="player-image img-responsive img-circle img-user margin-t5"
                            style={{ border: `2px solid ${borderColor}`, width: 50, height: 50 }} alt=""
                            onError={e => { e.target.src = DEFAULT_USER_PHOTO; }} />
                        <div className="center padding-t5"><span className="name"><b>{player ? player.User1Name : "TBA"}</b></span></div>
                        <div className="handicap center"><b>({h1 ?? 0})</b></div>
                    </div>
                    <div className="col-sm-6 text-center player-holder-2">
                        <img src={photo2} className="player-image img-responsive img-circle img-user margin-t5"
                            style={{ border: `2px solid ${borderColor}`, width: 50, height: 50 }} alt=""
                            onError={e => { e.target.src = DEFAULT_USER_PHOTO; }} />
                        <div className="center padding-t5"><span className="name"><b>{player ? player.User2Name : "TBA"}</b></span></div>
                        <div className="handicap center"><b>({h2 ?? 0})</b></div>
                    </div>
                </div>
            </div>
        );
    };

    // ─── ResultDisplay ────────────────────────────────────────────────────────────
    const ResultDisplay = ({ winner, winnerHoles, playerVs, lhsUserId }) => {
        if (!winner) {
            return <img src={VS_IMAGE} alt="vs" style={{ width: 85, height: 85 }} />;
        }

        const isLhs  = winner.User1ID === lhsUserId;
        const color  = isLhs ? COLOR_RED : COLOR_BLUE;

        if (winner.IsWalkOver === "Y") {
            return (
                <div className="text-center">
                    <img src={VS_IMAGE} alt="vs" style={{ width: 85, height: 85 }} />
                        <div>
                            <div style={{
                            display : "flex",
                            justifyContent: isLhs ? "flex-start" : "flex-end",
                            alignItems: "center",
                        }}>
                            <span style={{
                                backgroundColor: color, color: "#fff",
                                padding: "2px 10px", borderRadius: 4, fontSize: 12,
                                display: "inline-block", marginTop: 4,marginLeft: "2px",
                            }}>
                                {isLhs ? "← " : ""}Walkover{!isLhs ? " →" : ""}
                            </span>
                        </div>
                    </div>
                </div>
            );
        }

        const showWinner  = playerVs?.IsCardSubmitted === "Y";
        const pointDisplay = winner.Point === 0
            ? <h4 style={{ color, margin: 0 }}>AS</h4>
            : <span style={{color,}}>
                <strong style={{ fontWeight: 700, fontSize: "3rem" }}>
                    {winner.Point}
                </strong>{" "}
                up
            </span>;

        const hole = winnerHoles?.length === 1
            ? `THRU #${winnerHoles[0].Hole}`
            : winnerHoles?.length > 1 ? `THRU #${winnerHoles.length}` : "";
        
        return (
            <div className="result result-2">
                {showWinner && (
                    <div style={{
                        display : "flex",
                        justifyContent: isLhs ? "flex-start" : "flex-end",
                        alignItems: "center",
                    }}>
                        <span className="result_status" style={{
                        backgroundColor: color, color: "#fff",
                        padding: "2px 10px", borderRadius: 4, fontSize: 12,
                            display: "inline-block", marginBottom: 4,
                            marginLeft: "2px",
                        }}>Winner</span>
                        </div>
                )}
                <div className="result_points margin-t10">{pointDisplay}</div>
                {hole && <div className= "result_hole" style={{ color, fontSize: 11 }}>{hole}</div>}
            </div>
        );
    };

    return (
        <div
            className={`card pnl-match margin-b20`}
            onClick={() => clickable && onMatchClick(playerVs)}
            style={{ cursor: clickable ? "pointer" : "default" }}
        >
            <div className="card-header padding-0" style={{ height: 36 }}>
                <div className="card-title w-100">
                    <div className="row w-100 mx-0">
                        <div className="col-5">
                            <h6 className="margin-t10 margin-l15">
                                <strong>Match {matchIndex}</strong>
                            </h6>
                        </div>
                        <div className="col-2 text-center">
                            <h6 className="margin-t10">
                                <strong>Group {groupIndex}</strong>
                            </h6>
                        </div>
                        {/*  style={{ lineHeight: "36px" }} */}
                        <div className="col-5 text-right margin-t5 lbl-verification">
                            <VerificationBadge isSubmitted={isSubmitted} isVerified={isVerified} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="card-body">
                <div className="row align-items-center">
                    {/* LHS */}
                    <div className="col-sm-5 text-center">
                        {type === "Singles"
                            ? <PlayerSlot player={lhsReg} userPhotoURL={userPhotoURL} side="lhs" handicap={playerVs?.User1Handicap} />
                            : <DoublesSlot player={lhsReg} userPhotoURL={userPhotoURL} side="lhs" h1={playerVs?.User1Handicap} h2={playerVs?.User2Handicap} />
                        }
                    </div>

                    {/* Centre: VS / Result */}
                    <div className="col-sm-2 text-center">
                        <div className="col-xs-2">
                            <div className="result-holder">
                                <ResultDisplay
                                    winner={winner}
                                    winnerHoles={winnerHoles}
                                    playerVs={playerVs}
                                    lhsUserId={lhsUserId}
                                    />
                            </div>
                        </div>
                    </div>

                    {/* RHS */}
                    <div className="col-sm-5 text-center">
                        {playerVs?.IsBye === "Y"
                            ? <h3 style={{ paddingTop: 45 }}>BYE</h3>
                            : type === "Singles"
                                ? <PlayerSlot player={rhsReg} userPhotoURL={userPhotoURL} side="rhs" handicap={playerVs?.User2Handicap} />
                                : <DoublesSlot player={rhsReg} userPhotoURL={userPhotoURL} side="rhs" h1={playerVs?.User3Handicap} h2={playerVs?.User4Handicap} />
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MatchCard;
